import { jsx as a, jsxs as e } from "react/jsx-runtime";
import { useTranslation as g, useSession as m, GenericLink as h, FAIcon as z, Theme as n, IconStyle as C, Tag as V, TagStyle as f, TagWidth as _, NextgenImage as k } from "@nextgen-web-framework/all";
import { ConfigService as y } from "@nextgen-web-framework/core";
import { UrlKeyEnum as i } from "../../utils/common.js";
import '../../assets/MyAccountSection.css';const S = "#ffffff", A = "#396e75", T = "#e5fdff", B = "#546223", N = "#f0fae5", E = "#a65523", O = "#fff1e8", P = "#7f3e3e", R = "#ffe2e2", b = "#62625a", v = "#f8f8e7", x = "#38539a", G = "#707070", W = "#c8f8d1", D = "#87c9c8", L = "#5291b1", w = "rgba(82, 145, 177, 0.1019607843)", I = "#445685", U = "#181d61", Y = "rgba(24, 29, 97, 0.1019607843)", $ = "#5969d6", H = "#ea999d", j = "#b6577e", F = "rgba(182, 87, 126, 0.1019607843)", K = "#7e3e80", M = "#1e247f", X = "rgba(30, 36, 127, 0.1019607843)", q = "#da7600", J = "#107f47", Q = "#d91734", Z = "_html_1a4lt_38", o = {
  amwayWhite: S,
  darkBlue: A,
  lightBlue: T,
  darkGreen: B,
  lightGreen: N,
  darkOrange: E,
  lightOrange: O,
  darkRed: P,
  lightRed: R,
  darkYellow: b,
  lightYellow: v,
  darkPurple: x,
  darkGrayOnWhite: G,
  dataVizColor1: W,
  dataVizColor2: D,
  dataVizColor3: L,
  dataVizColor3Background: w,
  dataVizColor4: I,
  dataVizColor5: U,
  dataVizColor5Background: Y,
  dataVizColor6: $,
  dataVizColor7: H,
  dataVizColor8: j,
  dataVizColor8Background: F,
  dataVizColor9: K,
  dataVizColor10: M,
  dataVizColor10Background: X,
  dataVizAlertOrange: q,
  dataVizSuccessGreen: J,
  dataVizWarningRed: Q,
  "no-visible": "_no-visible_1a4lt_34",
  html: Z,
  "user-account-card": "_user-account-card_1a4lt_72",
  "my-account-link": "_my-account-link_1a4lt_88",
  "user-account-icon": "_user-account-icon_1a4lt_94",
  "user-account-exclamation": "_user-account-exclamation_1a4lt_105",
  "user-account-card-details": "_user-account-card-details_1a4lt_116",
  "user-account-card-heading": "_user-account-card-heading_1a4lt_116"
}, ca = (t) => {
  var c;
  const r = g(), { session: l } = m(), { primaryProfile: d } = l, s = d ? "coapplicant" : "primary", u = y.getConfigs().NEXT_ASSETS_BASE_PATH;
  return /* @__PURE__ */ a(h, { href: `/my-account/${t.sectionData.link.url}`, className: o["my-account-link"], children: /* @__PURE__ */ e(
    "div",
    {
      className: o["user-account-card"],
      "data-testid": "user-account-card-testid",
      "data-pod-name": "commerce",
      children: [
        /* @__PURE__ */ a("div", { className: o["user-account-icon"], children: /* @__PURE__ */ a(z, { theme: n.PURPLE, iconName: t.sectionData.iconName, iconStyle: C.REGULAR }) }),
        /* @__PURE__ */ e("div", { className: o["user-account-card-details"], children: [
          /* @__PURE__ */ e("div", { className: o["user-account-card-heading"], children: [
            /* @__PURE__ */ a("h2", { children: t.sectionData.title }),
            " ",
            t.sectionData.link.url === i.CO_APPLICANT && /* @__PURE__ */ a("div", { children: /* @__PURE__ */ a(
              V,
              {
                style: f.SOLID,
                tagWidth: _.FULL_WIDTH,
                text: r(`web.tag.${s}`),
                theme: n.PURPLE,
                "data-testid": "owner-tag",
                "data-pod-name": "commerce"
              }
            ) }),
            ((c = t.sectionData.link.url) == null ? void 0 : c.includes(i.ACCOUNT_RENEWAL)) && t.isExclamation && /* @__PURE__ */ a("div", { className: o["user-account-exclamation"], children: /* @__PURE__ */ a(k, { src: `${u}/icons/triangle-exclamation.svg`, alt: "" }) })
          ] }),
          /* @__PURE__ */ a("h6", { children: t.sectionData.subTitle })
        ] })
      ]
    },
    `${t.sectionData.title}`
  ) });
};
export {
  ca as default
};
//# sourceMappingURL=MyAccountSection.js.map
